// export const API_URL = 'https://lmpng.enoch/api/scoringapp';
export const API_URL = 'https://api.letmeplay.com.au';

// export const API_URL = 'https://hillshornets.com.au/members/api/scoringapp';

// export const API_SYNC = 'https://lmpng.enoch/api/scoringapp';
export const API_SYNC = 'https://api.letmeplay.com.au';
